/**
 * Format a chord for tooltips, e.g. `[Ctrl+Z]` or `[⌘+Z]`.
 * Pass `modifierKey` as the first part when the shortcut uses Ctrl/⌘.
 */
export function formatHotkey(...keys: string[]): string {
  return `[${keys.join('+')}]`;
}
